import TrainingSession from '../session';

/**
 * Create the action
 */

const { thunk, request, success, error } = TrainingSession.store((data, fetch) => {
    // Prepare request
    let formData = new FormData();
    ['title', 'description', 'order_index', 'image', 'is_published']
        .map(key => data[key] !== undefined ? formData.append(key, data[key]) : null);
    
    return fetch.post(`/trainings/${data.trainingId}/sessions`, formData);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
